// AUTO-GENERATED by scripts/extractWorkingPaperTemplates.mjs — DO NOT EDIT BY HAND.
// Source: feedback/NTCSA Compliance Assurance Procedures - Various Procurement Mechanisms - 09072026.xlsx
//         + feedback/Other Divisions Working Paper Template.xlsx
import type { WorkingPaperTemplateMap } from './templateTypes';

export const WORKING_PAPER_TEMPLATES: WorkingPaperTemplateMap = {
  "NTCSA": {
    "Formal Tendering - Contracts": {
      "family": "NTCSA",
      "mechanism": "Formal Tendering - Contracts",
      "sheetName": "Formal Tendering - Contracts",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer / Division",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.1",
          "label": "1.1 Inspect the Purchase Requsition approved by the end-user Manager/SAP Screenshot",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.2",
          "label": "1.2 Inspect Cross Functional Teams (CFT) appointment letters",
          "anchors": []
        },
        {
          "seq": 3,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.3",
          "label": "1.3 Inspect Conflict Declaration status (DoI & NDA)",
          "anchors": [],
          "defaultLevelRaw": "non compliance PFMA - NDA or non-compliance policies - no DOI"
        },
        {
          "seq": 4,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.4",
          "label": "1.4 Inspect the approved strategy(commercial or procurement) by the relevant Delegated Adjudication Authority (DAA)",
          "anchors": []
        },
        {
          "seq": 5,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.5",
          "label": "1.5 If strategy was approved by a Committee inspect an extract of the meeting minutes of relevant Delegated Adjudication Authority (DAA)",
          "anchors": []
        },
        {
          "seq": 6,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.6",
          "label": "1.6 If amendment to the enquiry was required, inspect whether strategy was ratofied a /releCommittee inspect before publication of the strategy by relevant Delegated Adjudication Authority (DAA)",
          "anchors": []
        },
        {
          "seq": 7,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.1",
          "label": "2.1 Inspect the enquiry document (Invitation To Tender -ITT) signed by Procurement manager",
          "anchors": []
        },
        {
          "seq": 8,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.2",
          "label": "2.2 Check the alignment of the strategy and enquiry/ITT ensuring consistency in: *Scope of work *Evaluation process : -Basic compliance requirments -Pre-qualification criteria -Functionality (incl.minimum treshold) -Local content and production(if applicable) -objective criteria (if applicable) -including all other Evaluations -Contractual requirements",
          "anchors": []
        },
        {
          "seq": 9,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.3",
          "label": "2.3 Proof of advertisement to all relevant portals (National Treasury, Eskom Bulletin, and CIDB if is the requirement)",
          "anchors": [
            "32-1034: 8.8.6)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 10,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.4",
          "label": "2.4 Inspect the copy of advert and ensure it is consistent with the advert included on the the relevant portals",
          "anchors": []
        },
        {
          "seq": 11,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.4",
          "label": "2.4 If any of the systems was down at the time, verify if National Treasury E-Tender and CIDB was notified of the downtime and relevant screen shot has been uploaded (if there were system Problems)",
          "anchors": []
        },
        {
          "seq": 12,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.5",
          "label": "2.5 Where clarification queries were received before closing date, verify if they were addressed and published onto the relevant platforms (if applicable)",
          "anchors": []
        },
        {
          "seq": 13,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.1",
          "label": "3.1 Inspect the tender register with list of all bids received at tender closing date and time.",
          "anchors": []
        },
        {
          "seq": 14,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.2",
          "label": "3.2 Inspect the Proof that tender register was uploaded within 10 working days of closing on NT etender portal and published on NTCSA Tender Bulletin",
          "anchors": []
        },
        {
          "seq": 15,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.3",
          "label": "3.3 Inspect Signed DoI & NDA by all evaluators. If evaluators join CFT at evaluation stage inspect appointment letters",
          "anchors": []
        },
        {
          "seq": 16,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.4",
          "label": "3.4 Check and ensure alignment of evaluations with the approved strategy & enquiry issued",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 17,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.5",
          "label": "3.5 Inspect signed evaluations reports ( Commercial, Technical, SHEQ, SDL&I, QS / Financial Analysis including evaluation of price and preference) (for completeness) Note: Financial analysis is mandatory for CIDB-related transactions)",
          "anchors": []
        },
        {
          "seq": 18,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.6",
          "label": "3.6 Inspect the approved Technical evaluation report(s) and verify if the individual scoring sheets are appended.",
          "anchors": []
        },
        {
          "seq": 19,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.7",
          "label": "3.7 Inspect and confirm the following mandatory returnables (where applicable) * Declarations of interest (SBD4) * Declaration of local content and productions( incl. exemption letter if applicable) *Proof of validity of professional membership (if applicable)",
          "anchors": []
        },
        {
          "seq": 20,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.8",
          "label": "3.8 Inspect signed DAA submission template for alignment with evaluation reports and recommendation",
          "anchors": []
        },
        {
          "seq": 21,
          "group": "4. Assess compliance at adjudication & negotiations stage of the procurement process",
          "code": "4.1",
          "label": "4.1 Inspect the relevant DAA resolution (Award/mandate to negotiate)",
          "anchors": []
        },
        {
          "seq": 22,
          "group": "4. Assess compliance at adjudication & negotiations stage of the procurement process",
          "code": "4.2",
          "label": "4.2 Inspect negotiation pack : (Ref: 8.8.12.q) (if applicable)",
          "anchors": [
            "32-1034: 8.8.12(q))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 23,
          "group": "Assess compliance to adjudication",
          "code": "4.1",
          "label": "4.1 Check alignment of the negotiation outcome with the approved mandate",
          "anchors": []
        },
        {
          "seq": 24,
          "group": "Assess compliance to adjudication",
          "code": "4.2",
          "label": "4.2 Verify that the the proof is provided that the recommened supplier is tax compliant prior to submission to relevant DAA",
          "anchors": []
        },
        {
          "seq": 25,
          "group": "Assess compliance to adjudication",
          "code": "4.3",
          "label": "4.3 Inspect the approved adjudication reports recommendation to award (evaluation, mandate & feedback)",
          "anchors": []
        },
        {
          "seq": 26,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.1",
          "label": "5.1 Check if award is in line with the approval from the relevant DAA (minute/report)",
          "anchors": []
        },
        {
          "seq": 27,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.2",
          "label": "5.2 Inspect if the award is still within the validity period (internal approval, acceptance of extension from suppliers, publication of the extension)",
          "anchors": []
        },
        {
          "seq": 28,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.3",
          "label": "5.3 Inspect if NEC contract is Fully signed by all parties",
          "anchors": []
        },
        {
          "seq": 29,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.4",
          "label": "5.4 Inspect Compliance of the statutory documents of the awarded supplier (Tax, BBBEE, CIDB, CSD etc.)",
          "anchors": [
            "32-1034: 10.2.1"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 30,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.5",
          "label": "5.5 SDL&I targets are included as part of the signed NEC contract and are aligned with the approval by relevant DAA",
          "anchors": []
        },
        {
          "seq": 31,
          "group": "6. Assess compliance on Award Publication of the tender",
          "code": "6.1",
          "label": "6.1 Inspect proof of publication of successful and unsuccessful tenders on the National Treasury eTender Portal, Eskom Portal and CIDB Portals.",
          "anchors": [
            "32-1034: 8.8.14 (C))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 32,
          "group": "6. Assess compliance on Award Publication of the tender",
          "code": "6.2",
          "label": "6.2 Check if the contract has foreign component, if so, check if the forward cover was taken in line with the relevant threshold",
          "anchors": [
            "32-1034: 10.1.10)"
          ],
          "defaultLevelRaw": "non-conformance - possible FWE (Fruitless & Wasteful Expenditure)"
        },
        {
          "seq": 33,
          "group": "6. Assess compliance on Award Publication of the tender",
          "code": "6.3",
          "label": "6.3 Compare alignment of the awarded contract with SAP and adjudication report minutes. E.g., Target value, contigency, SDL&I etc.",
          "anchors": [
            "32-1034: 8.8.14 (d))"
          ],
          "defaultLevelRaw": "possible non-compliance if not in line with DAA approval"
        },
        {
          "seq": 34,
          "group": "6. Assess compliance on Award Publication of the tender",
          "code": "6.4",
          "label": "6.4 Proof that award has been uploaded on NT e-tender and other relevant platforms and contract registered on e-tender portal with 30 days of contracts signing.",
          "anchors": []
        },
        {
          "seq": 35,
          "group": "7. Assess compliance on Documents Management process",
          "code": "7.1",
          "label": "7.1 Inspect if all relevant documents are uploaded on OpenText",
          "anchors": []
        }
      ]
    },
    "Informal Tendering - PO's": {
      "family": "NTCSA",
      "mechanism": "Informal Tendering - PO's",
      "sheetName": "Informal Tendering - PO's",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "Assess the intiation process",
          "code": "1.1",
          "label": "1.1 Inspect the Purchase Requsition approved by the end-user Manager",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "Assess the intiation process",
          "code": "1.2",
          "label": "1.2 Check if the transaction does not exceed a maximum value of R1m.",
          "anchors": [
            "32-1034: 8.7.1)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 3,
          "group": "Assess the intiation process",
          "code": "1.3",
          "label": "1.3 Proof that the required minimum number of bidders were sourced from CSD or augmented from the VMS( 6 minimum quotes received)",
          "anchors": []
        },
        {
          "seq": 4,
          "group": "2. Assess compliance with issuing process",
          "code": "2.1",
          "label": "2.1 Check if the RFQ was issued via the CSD RFQ platform.",
          "anchors": [
            "Instruction Note 03 of 2025"
          ],
          "defaultLevelRaw": "Depends on when the transaction took place vs departure"
        },
        {
          "seq": 5,
          "group": "2. Assess compliance with issuing process",
          "code": "2.2",
          "label": "2.2 Check if the issued RFQ included the scope, specifications and price schedules, as well as any drawings that where applicable",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "Depends - which doc is legislative . i.e SBD4"
        },
        {
          "seq": 6,
          "group": "2. Assess compliance with issuing process",
          "code": "2.3",
          "label": "2.3 Check if the following documents were attached to the RFQ and stipulated as mandatory tender returnables for evaluation: 1 Authorisation Form; 2. Integrity Pact & Integrity Declaration Form, 3. SBD 4 form (Bidder’s Declaration of Interest)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 7,
          "group": "2. Assess compliance with issuing process",
          "code": "2.4",
          "label": "2.4Check if the functionality and SDL&I requirements were applicable, if so, were they issued the RFQ pack.",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "Depends is \"6\" an Eskom requirement?"
        },
        {
          "seq": 8,
          "group": "3. Assess compliance at evaluation level of the procurement process",
          "code": "3.1",
          "label": "3.1 Check signed evaluations sheets (e.g., Commercial, Technical, SHEQ, SDL&I, QS etc.)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 9,
          "group": "3. Assess compliance at evaluation level of the procurement process",
          "code": "3.2",
          "label": "3.2 Check if the End-user and the Procurement Practitioner have completed a conflict of interest declaration (COI)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 10,
          "group": "3. Assess compliance at evaluation level of the procurement process",
          "code": "3.3",
          "label": "3.3 Check if the recommended supplier was the highest score in terms of the PPPFA, subject to the application of objective criteria if those were specified in the RFQ",
          "anchors": [
            "PPPFA"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 11,
          "group": "3. Assess compliance at evaluation level of the procurement process",
          "code": "3.4",
          "label": "3.4 Check if the Procurement Practitioner did ascertain that the prices are fair, reasonable and market-related before recommending an order / contract.",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 12,
          "group": "4.Assess compliance at adjudication & negotiations level of the procurement process",
          "code": "4.1",
          "label": "4.1 Check approved adjudication reports (evaluation, mandate",
          "anchors": []
        },
        {
          "seq": 13,
          "group": "4.Assess compliance at adjudication & negotiations level of the procurement process",
          "code": "4.2",
          "label": "4.2 Verify that supplier was tax compliant before submission to DAA",
          "anchors": []
        },
        {
          "seq": 14,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.1",
          "label": "5.1 Check if award is in line with the approval from the relevant DAA (report)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 15,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.2",
          "label": "5.2 Check the Fully signed PO by all parties.",
          "anchors": []
        },
        {
          "seq": 16,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.3",
          "label": "5.3 Compare alignment of the awarded Adjuducation report, PO with SAP amount",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 17,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.4",
          "label": "5.4 Inspect Compliance of the statutory documents of the awarded supplier (Tax, BBBEE, CSD, SBD4 etc.)",
          "anchors": [
            "32-1034: 10.2.1"
          ]
        }
      ]
    },
    "LPO": {
      "family": "NTCSA",
      "mechanism": "LPO",
      "sheetName": "LPO",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "Justification of the LPO",
          "code": "1.2",
          "label": "1.2 Inspect the Purchase Requsition from SAP OR written request approved by the end-user Manager",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "Justification of the LPO",
          "code": "1.2",
          "label": "1.2 Check if the transaction does not exceed a maximum value of R30000.00 (excl. VAT).",
          "anchors": []
        },
        {
          "seq": 3,
          "group": "Assess compliance to the process of sourcing and issuing of LPO",
          "code": "2.1",
          "label": "2.1 Proof that the required minimum number of bidders were sourced from CSD or Eskom vendor ( 3 minimum quotes received)",
          "anchors": []
        },
        {
          "seq": 4,
          "group": "Assess compliance to the process of sourcing and issuing of LPO",
          "code": "2.2",
          "label": "2.2 If CSD is unavailable: Inspected the proof of the following supporting evidence : *Take a screenshot of CSD unavailability. *Seek Procurement Manager approval for market research to identify tenderers. *Keep records of market research and analysis conducted. *Get Procurement Manager sign-off before issuing the RFQ.",
          "anchors": []
        },
        {
          "seq": 5,
          "group": "Assess compliance to the process of sourcing and issuing of LPO",
          "code": "2.3",
          "label": "2.3 Check if the RFQ was issued via LPO Buyer email",
          "anchors": []
        },
        {
          "seq": 6,
          "group": "Assess compliance to the process of sourcing and issuing of LPO",
          "code": "2.4",
          "label": "2.4 Check if the issued RFQ included the scope, specifications and price schedules",
          "anchors": []
        },
        {
          "seq": 7,
          "group": "Assess compliance to the process of sourcing and issuing of LPO",
          "code": "2.5",
          "label": "2.5 Check if the following documents were attached to the RFQ: 1 Authorisation Form; 2. Integrity Pact & Integrity Declaration Form, 3. SBD 4 form (Bidder’s Declaration of Interest)",
          "anchors": []
        },
        {
          "seq": 8,
          "group": "Assess compliance to the process of sourcing and issuing of LPO",
          "code": "2.6",
          "label": "2.6 Check if the RFQ(s) was/were received at the closing date and time stipulated as per the issued RFQ.",
          "anchors": []
        },
        {
          "seq": 9,
          "group": "Assess compliance to the process of sourcing and issuing of LPO",
          "code": "2.7",
          "label": "2.7 If the RFQ was cancelled, check that LPO buyer informed tenderers.",
          "anchors": []
        },
        {
          "seq": 10,
          "group": "Evaluation of LPO",
          "code": "3.1",
          "label": "3.1 Check if the End-user and the Procurement Practitioner have completed a conflict of interest declaration (COI)",
          "anchors": []
        },
        {
          "seq": 11,
          "group": "Evaluation of LPO",
          "code": "3.2",
          "label": "3.2 Check if the recommended supplier was the highest score in terms of the PPPFA, subject to the application of objective criteria if those were specified in the RFQ",
          "anchors": [
            "PPPFA"
          ]
        },
        {
          "seq": 12,
          "group": "4.Assess compliance of award process",
          "code": "4.1",
          "label": "4.1 Check whether DAA approval is for : 1.Supplier is tax complaint 2. Award to highest ranked tenderer, unless obejective criteria specified in RFQ justify the award to a different tenderer. 3. LPO description is aligned to what is being ultimately purchased 4. Price to be paid is market-related",
          "anchors": []
        },
        {
          "seq": 13,
          "group": "4.Assess compliance of award process",
          "code": "4.2",
          "label": "4.2 Check the Fully signed LPO by all parties.",
          "anchors": []
        },
        {
          "seq": 14,
          "group": "4.Assess compliance of award process",
          "code": "4.3",
          "label": "4.3 Inspect Compliance of the statutory documents of the awarded supplier (Tax, BBBEE, CSD etc.)",
          "anchors": []
        }
      ]
    },
    "Emergency": {
      "family": "NTCSA",
      "mechanism": "Emergency",
      "sheetName": "Emergency Post LS",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User",
        "Approver of the Urgent Request Form"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Assess the declaration of the emergency procurement route",
          "code": "1.1",
          "label": "1.1 Emergency purchasing request Form (or e-mail form was not readily available) approved by CE",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "1. Assess the declaration of the emergency procurement route",
          "code": "1.2",
          "label": "1.2 End-User and GM conflict of interest declaration",
          "anchors": []
        },
        {
          "seq": 3,
          "group": "1. Assess the declaration of the emergency procurement route",
          "code": "1.3",
          "label": "1.3. Justification aligns with the conditions prescribed for Emergency Procurement route",
          "anchors": []
        },
        {
          "seq": 4,
          "group": "1. Assess the declaration of the emergency procurement route",
          "code": "1.4",
          "label": "1.4. Verification if the scope of work does not fall within the one of the existing framework agreement.",
          "anchors": []
        },
        {
          "seq": 5,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.2",
          "label": "2.2. Completed Emergency Request for Quotation (RFQ) from the supplier(s).",
          "anchors": []
        },
        {
          "seq": 6,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.2",
          "label": "2.2. Evidence of verification of the winning bidders tax compliance on or before the date of award date. In the form of: a) CSD report indicating tax compliance status OR ; b) SARS confirmation of tax compliance status",
          "anchors": []
        },
        {
          "seq": 7,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.3",
          "label": "2.3. Proof of: a) Signed supplier’s integrity declaration form (SBD4); and b) Completed PAYE Questionnaire (if applicable) OpenText Template)",
          "anchors": []
        },
        {
          "seq": 8,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.4",
          "label": "2.4. End-User and GM conflict of interest declaration",
          "anchors": []
        },
        {
          "seq": 9,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.5",
          "label": "2.5. Emergency Procurement Ratification Request Form supported by GM as subdelegated by the CE.",
          "anchors": []
        },
        {
          "seq": 10,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.6",
          "label": "2.6. Ratification Request Form supported by GM for submission to R1.5bn TC",
          "anchors": []
        },
        {
          "seq": 11,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.7",
          "label": "2.7. Minutes of Ratification of emergency by R1.5bn TC.",
          "anchors": []
        },
        {
          "seq": 12,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.8",
          "label": "2.8. SAP Purchase order created by procurement practitioner and approved/authorised by manager procurement",
          "anchors": []
        },
        {
          "seq": 13,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.9",
          "label": "2.9. Verification of supplier tax compliant status at order/contract placement",
          "anchors": []
        },
        {
          "seq": 14,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.10",
          "label": "2.10. Verify if the contract is completely signed",
          "anchors": []
        },
        {
          "seq": 15,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.11",
          "label": "2.11. Verify if the Emergency Procurement transaction was/has been reported to NT and to the AGSA within 14 days after finalisation of the procurement",
          "anchors": []
        }
      ]
    },
    "Urgent": {
      "family": "NTCSA",
      "mechanism": "Urgent",
      "sheetName": "Urgent Post LS ",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User",
        "Approver of the Urgent Request Form"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.1",
          "label": "1.1 Urgent Procurement Request Form recommended by user GM, supported by Senior Manager (P&SCM) and approved by Independent GM",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.2",
          "label": "1.2 End-User and GM conflict of interest declaration",
          "anchors": []
        },
        {
          "seq": 3,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.3",
          "label": "1.3. Budget letter approved by the finance manager",
          "anchors": []
        },
        {
          "seq": 4,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.4",
          "label": "1.4. Justification aligns with the conditions prescribed for Urgent Procurement route",
          "anchors": []
        },
        {
          "seq": 5,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.5",
          "label": "1.5. Proof of where potential suppliers where sourced ( i.e. CSD or Eskom Vendor Database), minimum of three suppliers invited.",
          "anchors": []
        },
        {
          "seq": 6,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.1",
          "label": "2.1. Completed Urgent Request for Quotation (RFQ) form by the supplier(s).",
          "anchors": []
        },
        {
          "seq": 7,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.2",
          "label": "2.2. Evidence of verification of the winning bidders tax compliance on or before the date of award date. In the form of: a) CSD report indicating tax compliance status or ; b) SARS confirmation of tax compliance status;",
          "anchors": []
        },
        {
          "seq": 8,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.3",
          "label": "2.3. Proof of: a) Signed supplier’s integrity declaration form (SBD4); b)Completed PAYE Questionnaire (if applicable) (as per OpenText Template)",
          "anchors": []
        },
        {
          "seq": 9,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.4",
          "label": "2.4. Check the evaluation process of the prospective supplier’s offer (all applicable evaluation disciplines as per the approved RFQ)",
          "anchors": []
        },
        {
          "seq": 10,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.5",
          "label": "2.5. Completed evaluation template in respect of preference points (PPR 2022).",
          "anchors": [
            "PPR 2022"
          ]
        },
        {
          "seq": 11,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.6",
          "label": "2.6. Verify if the submission was in accordance with the specified closing date",
          "anchors": []
        },
        {
          "seq": 12,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.7",
          "label": "2.7. In case where a mandate to negotiate was sought from the relevant DAA, check the approved mandate to negotiate report, negotiation pack (agenda, signed negotiation minutes by both parties, signed attendance register by both parties) and approved feedback report by the relevant DAA",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 13,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.8",
          "label": "2.8.Urgent Procurement Ratification Request Form signed by the end-user and GM,supported by the Senior Manager (P&SCM) and approved by the independent GM.",
          "anchors": []
        },
        {
          "seq": 14,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.9",
          "label": "2.9. Urgent Procurement Ratification request form approved by the relevant DAA.",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 15,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.10",
          "label": "2.10.SAP Purchase order created by procurement practitioner and approved/authorised by senior manager procurement or contract (contract not longer than 12 months)",
          "anchors": []
        },
        {
          "seq": 16,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.11",
          "label": "2.11.Verify if the PO/contract is completely signed",
          "anchors": []
        },
        {
          "seq": 17,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.12",
          "label": "2.12. Verify if the contract does not exceed 12 months",
          "anchors": []
        },
        {
          "seq": 18,
          "group": "2. Process once Urgent Procurement has been approved",
          "code": "2.13",
          "label": "2.13. Verify if the Urgent Procurement transaction was/has been reported to NT and to the AGSA within 30 days after finalisation of the procurement and registered on NT e-tender within date of PO or contract",
          "anchors": []
        }
      ]
    },
    "Sole Source": {
      "family": "NTCSA",
      "mechanism": "Sole Source",
      "sheetName": "Sole Source ",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1.Identifying when it is permissible to use the Sole Source mechanism",
          "code": "1.1",
          "label": "1.1 Approved Sole source justification form (SSJF)with a detailed motivation completed by all the signatories.",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "1.Identifying when it is permissible to use the Sole Source mechanism",
          "code": "1.2",
          "label": "1.2. True Sole source(monopoly) (If applicable) Verify if informed by the market research (Desktop Market Analysis, EOI, RFI, or BI Report).",
          "anchors": []
        },
        {
          "seq": 3,
          "group": "1.Identifying when it is permissible to use the Sole Source mechanism",
          "code": "1.3",
          "label": "1.3. Sole source -Incompatible Material (if applicable) CFT analysis of the cost versus benefit of changing the whole material component against the cost benefit of procuring through the sole source.",
          "anchors": []
        },
        {
          "seq": 4,
          "group": "2. Establishing whether there is competition in the market",
          "code": "2.1",
          "label": "2.1. Was the market research conducted in line the methods provided at 8.9.1 (a)?",
          "anchors": []
        },
        {
          "seq": 5,
          "group": "2. Establishing whether there is competition in the market",
          "code": "2.2",
          "label": "2.2. Formal valid letter confirming the company as an original equipment manufacturer, intellectual property (IP) holder, or a party to an exclusivity agreement.",
          "anchors": []
        },
        {
          "seq": 6,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.1",
          "label": "3.1 Proof that the supplier is an OEM/True Sole Source.",
          "anchors": []
        },
        {
          "seq": 7,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.2",
          "label": "3.2. Signed CFT appointment letters",
          "anchors": []
        },
        {
          "seq": 8,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.3",
          "label": "3.3. Signed CFT DoIs and NDAs",
          "anchors": []
        },
        {
          "seq": 9,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.4",
          "label": "3.4. Approved Commercial strategy by the relevant DAA",
          "anchors": []
        },
        {
          "seq": 10,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.5",
          "label": "3.5. Approved Mandate to negotiate - no prior tendering. (if applicable)",
          "anchors": []
        },
        {
          "seq": 11,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.6",
          "label": "3.6. Minutes of the relevant DAA approving the sole source supplier(s)",
          "anchors": []
        },
        {
          "seq": 12,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.7",
          "label": "3.7. RFQ and mandatory returnables obtained from the identified sole supplier(s)",
          "anchors": []
        },
        {
          "seq": 13,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.8",
          "label": "3.8. Evidence of verification of the bidder's tax compliance on or before submission to relevant DAA.",
          "anchors": []
        },
        {
          "seq": 14,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.9",
          "label": "3.9. Proof of: a) Completed PAYE Questionnaire (if applicable), b) Signed supplier’s integrity declaration form (SBD 4)",
          "anchors": []
        },
        {
          "seq": 15,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.10",
          "label": "3.10.Completed evaluation template in respect of (as per Opentext Template) including the technical evaluation report.",
          "anchors": []
        },
        {
          "seq": 16,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.11",
          "label": "3.11. Check the adjudication process by the relevant DAA (Evaluation / Mandate & Feedback)",
          "anchors": [
            "32-1034: 8.9.1 (c))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 17,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.12",
          "label": "3.12 If negotiations were held, approval of negotiation outcome and feedback report by relevant DAA",
          "anchors": []
        },
        {
          "seq": 18,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.13",
          "label": "3.13. Verify the captured contract value on SAP vs the approved target value",
          "anchors": []
        },
        {
          "seq": 19,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.14",
          "label": "3.14. Contract is signed by both parties",
          "anchors": [
            "32-1034: 8.8.14 (b))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 20,
          "group": "3. Process once a prospective Sole Source Supplier has been identified",
          "code": "3.15",
          "label": "3.15. Verify if the Sole Source transaction reported to NT and to the AGSA within 30 days after finalisation of the procurement and registed of e-tenders within 30 days of contract signing",
          "anchors": []
        }
      ]
    },
    "Single Source": {
      "family": "NTCSA",
      "mechanism": "Single Source",
      "sheetName": "Single Source ",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.1",
          "label": "1.1. Approved Single Source Justification Form completed by all the signatories",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.2",
          "label": "1.2 Evidence of market research/analysis (through an Desktop/EOI/RFI/BI) to justify the preferred option/supplier",
          "anchors": []
        },
        {
          "seq": 3,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.3",
          "label": "1.3 Determine whether the process of identifying the preferred supplier was both transparent and equitable",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 4,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.4",
          "label": "1.4 Check the formal cost / benefit analysis conducted to establish whether it is more cost-effective to continue with the on-site, established supplier, or whether it would be beneficial to request competitive proposals.",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 5,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.1",
          "label": "2.1. CFT appointment letters",
          "anchors": []
        },
        {
          "seq": 6,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.2",
          "label": "2.2. Signed CFT DoIs and NDAs",
          "anchors": []
        },
        {
          "seq": 7,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.3",
          "label": "2.3 Approved Commercial strategy by relevant DAA",
          "anchors": []
        },
        {
          "seq": 8,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.4",
          "label": "2.4. Approved Mandate to negotiate - no prior tendering (if applicable).",
          "anchors": []
        },
        {
          "seq": 9,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.5",
          "label": "2.5. Minutes of the relevant DAA approving the single source supplier(s)",
          "anchors": []
        },
        {
          "seq": 10,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.6",
          "label": "2.6. RFQ and mandatory returnables obtained from the identified single source supplier(s)",
          "anchors": []
        },
        {
          "seq": 11,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.7",
          "label": "2.7. Evidence of verification of the bidders tax compliance on or before the date of submission to relevant DAA for award",
          "anchors": []
        },
        {
          "seq": 12,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.8",
          "label": "2.8. Proof of: a) Signed supplier’s integrity declaration form (SBD 4) b) Completed PAYE Questionnaire (if applicable)",
          "anchors": []
        },
        {
          "seq": 13,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.9",
          "label": "2.9 Check the evaluation process of the prospective supplier’s offer (all applicable evaluation disciplines as per the approved strategy)",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 14,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.10",
          "label": "2.10. Completed evaluation template in respect of preference points (PPR 2022).",
          "anchors": [
            "PPR 2022"
          ]
        },
        {
          "seq": 15,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.11",
          "label": "2.11. Signed evaluation report including the technical evaluation",
          "anchors": []
        },
        {
          "seq": 16,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.12",
          "label": "2.12. Check the adjudication process by the relevant DAA (Evaluation / Mandate & Feedback)",
          "anchors": []
        },
        {
          "seq": 17,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.13",
          "label": "2.13. If negotiations were held, approval of negotiation outcome and feedback report by relevant DAA",
          "anchors": []
        },
        {
          "seq": 18,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.14",
          "label": "2.14. Verify the captured contract value on SAP vs the approved target value",
          "anchors": []
        },
        {
          "seq": 19,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.15",
          "label": "2.15. Verify if the contract is completely signed",
          "anchors": []
        },
        {
          "seq": 20,
          "group": "2. Process once a prospective Single Source Supplier has been identified",
          "code": "2.16",
          "label": "2.16. Verify if the Single Source transaction reported to NT and to the AGSA within 30 days after finalisation of the procurement and registered on NT e-etenders.",
          "anchors": [
            "Procurement Instruction 09 of 2024 Compare alingement with awarded Contract and SAP Taget value, contingency"
          ],
          "defaultLevelRaw": "possible non-compliance"
        }
      ]
    },
    "Expansions - Modifications": {
      "family": "NTCSA",
      "mechanism": "Expansions - Modifications",
      "sheetName": "Expansions - Modifications",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Identifying when it is permissible to request a modification",
          "code": "1.2",
          "label": "1.2 Proof of request for modification, in the form of : Completed modification report addressed to the chairperson of the relevant DAA",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "1. Identifying when it is permissible to request a modification",
          "code": "1.2",
          "label": "1.2 Check if the modification request form has been signed off by the relevant Senior Manager/General Manager supported by the Middle Manager *Risk assessment/Purchase requisition with amendend/proposed budget *confirmation/and all other *supporting documents (PTC, DTC or higher committee) for approval.",
          "anchors": []
        },
        {
          "seq": 3,
          "group": "1. Identifying when it is permissible to request a modification",
          "code": "1.3",
          "label": "1.3 Check if the approval of the modification was written and signed by the relevant DAA, confirming that the envisaged expenditure has been budgeted for.",
          "anchors": []
        },
        {
          "seq": 4,
          "group": "1. Identifying when it is permissible to request a modification",
          "code": "1.4",
          "label": "1.4 Verify the procurment mechanism modified (Note: modifications may not be sought in respect of LPOs, low-value informal tendering, or Emergency Procurement",
          "anchors": []
        },
        {
          "seq": 5,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.1",
          "label": "2.1 Check if the modification request was requested via Procurement Department when there was still sufficient time to obtain approval for the modification, which must be before the SAP expiry date of the contract",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 6,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.2",
          "label": "2.2 Check if the provided motivation including the provided risk assessment warrant contract modification.",
          "anchors": []
        },
        {
          "seq": 7,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.3",
          "label": "2.3 Check if the SDL&I targets / commitments were adjusted in order to benefit from increases in the contract value.",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 8,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.4",
          "label": "2.4 Verify supplier's tax compliance status before submission to relevant the DAA that approved the original contract.",
          "anchors": []
        },
        {
          "seq": 9,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.5",
          "label": "2.5 Check if the requests for modification was addressed to the DAA that approved the original contract.",
          "anchors": []
        },
        {
          "seq": 10,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.7",
          "label": "2.7 Check if there's proof that the authorised supplier’s representative accepted new conditions, in the form of a ,contract modification letter addressed to the supplier and returned by the supplier back to procurement/NTCSA(as acknowledgment of change) and that the authorised NTCSA representative signed the amendment / modification to the contract.",
          "anchors": []
        },
        {
          "seq": 11,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.8",
          "label": "2.8 Completed modification letter -internal use only (For the purpose of initiating a purchase order)",
          "anchors": []
        },
        {
          "seq": 12,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.9",
          "label": "2.9 Check if the Procurement Practitioner updated the electronic purchasing system (SAP) with the amended contract values and/or time, and/or the amended contingency value and time and filed the original amendment with the rest of the contract documents for audit purposes",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 13,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.8",
          "label": "2.8 Verify that the modification has been reported to National Treasury and AGSA within a month (if applicable as per NT IN 3 of 21/22). All modifications must be reported on the NT e-tenders portal within 30 days on the contract amendment.",
          "anchors": []
        }
      ]
    },
    "Task Order": {
      "family": "NTCSA",
      "mechanism": "Task Order",
      "sheetName": "Panel Task Order",
      "headerFields": [
        "Brief Description",
        "Supplier Name/Vendor Number",
        "Contract/PO Number",
        "Price",
        "Buyer's name",
        "Manager",
        "links"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "Section 1",
          "code": "1.1",
          "label": "1.1 Inspect the approved purchase requisition OR Task order request form",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "Section 1",
          "code": "1.2",
          "label": "1.2.Inspect the budget confirmation",
          "anchors": []
        },
        {
          "seq": 3,
          "group": "Section 1",
          "code": "1.3",
          "label": "1.3.Inspect the minutes of PCC to confirm approval of task order",
          "anchors": []
        },
        {
          "seq": 4,
          "group": "Section 1",
          "code": "1.4",
          "label": "1.4.Inspect Cross Functional Teams (CFT) appointment letters for Evaluators",
          "anchors": []
        },
        {
          "seq": 5,
          "group": "Section 1",
          "code": "1.5",
          "label": "1.5.Inspect Conflict of Interest Declaration and NDAs",
          "anchors": []
        },
        {
          "seq": 6,
          "group": "Section 2",
          "code": "2.1",
          "label": "2.1.Inspect the Request For Quotation(RFQ) signed by Procurement manager",
          "anchors": []
        },
        {
          "seq": 7,
          "group": "Section 2",
          "code": "2.2",
          "label": "2.2. Inspect the RFQ was sent out to the suppliers within the panel",
          "anchors": []
        },
        {
          "seq": 8,
          "group": "Section 2",
          "code": "2.3",
          "label": "2.3.Confirm that the RFQs were received by closing date as stipulated on the RFQ.",
          "anchors": []
        },
        {
          "seq": 9,
          "group": "Section 3",
          "code": "3.1",
          "label": "3.1. Inspect signed individual evaluations sheets ( Commercial, Technical (if applicable), SHEQ, SDL&I, QS / Financial Analysis including evaluation of price and preference) Note: Financial analysis is mandatory for CIDB-related transactions)",
          "anchors": []
        },
        {
          "seq": 10,
          "group": "Section 3",
          "code": "3.2",
          "label": "3.2 Inspect the approved evaluation report(s) by the evaluators",
          "anchors": []
        },
        {
          "seq": 11,
          "group": "Section 3",
          "code": "3.3",
          "label": "3.3. Inspect submission for mandate to negotiate to the Panel Control Committee/Task order Committee",
          "anchors": []
        },
        {
          "seq": 12,
          "group": "Section 3",
          "code": "3.4",
          "label": "3.4 Inspect the minutes by PCC/TOC to approve submission",
          "anchors": []
        },
        {
          "seq": 13,
          "group": "Section 4",
          "code": "4.1",
          "label": "4.1.Inspect if the award is still within the validity period.",
          "anchors": []
        },
        {
          "seq": 14,
          "group": "Section 4",
          "code": "4.2",
          "label": "4.2 Confirm whether tax compliance status was verified prior to submission to DAA",
          "anchors": []
        },
        {
          "seq": 15,
          "group": "Section 4",
          "code": "4.3",
          "label": "4.3 Inspect that the Contract/task order has been signed by the relevant appointed signatory and supplier.",
          "anchors": []
        },
        {
          "seq": 16,
          "group": "Section 4",
          "code": "4.4",
          "label": "4.4. Verify that the approved contract period of the is within the validity of the Panel Framework Agreement",
          "anchors": []
        },
        {
          "seq": 17,
          "group": "Section 5",
          "code": "5.1",
          "label": "5.1.Inspect if all relevant documents are uploaded on OpenText",
          "anchors": []
        },
        {
          "seq": 18,
          "group": "Section 5",
          "code": "5.2",
          "label": "5.2 Confirm that the award on of orders > R1mil are registered on NT e-tenders.",
          "anchors": []
        }
      ]
    },
    "Transversal": {
      "family": "NTCSA",
      "mechanism": "Transversal",
      "sheetName": "Transversal",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Procurement Practitioner",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "",
          "code": "1",
          "label": "1. Inspect the Market research and analysis done to confirm that there are only a few known suppliers who are able to provide the goods, works or services. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 2,
          "group": "",
          "code": "2",
          "label": "2. Inspect whether the approved commercial strategy, authorised the use of the multiple source mechanism. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 3,
          "group": "",
          "code": "3",
          "label": "3. Check that the relevant DAA approved the award of the successful tenderer . (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 4,
          "group": "",
          "code": "4",
          "label": "4. Was tax compliance verified BEFORE submission to DAA. (CSD Report) (32-1034: 8.9.3 Multiple Sources and ) ( Instr note 01 of 2026)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources and ) ( Instr note 01 of 2026)"
          ],
          "defaultLevelRaw": "non-compliance"
        },
        {
          "seq": 5,
          "group": "",
          "code": "5",
          "label": "5. Check that the multiple source procurement was reported to NT after finalisation. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-compliance"
        }
      ],
      "supportsGaps": true,
      "gapColumns": {
        "description": "Gaps Identified",
        "complianceLevel": "Compliance level for each GAP",
        "contravention": "Reference of contravention"
      }
    },
    "Multiple Sources": {
      "family": "NTCSA",
      "mechanism": "Multiple Sources",
      "sheetName": "Multisource",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Procurement Practitioner",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "",
          "code": "1",
          "label": "1. Inspect the Market research and analysis done to confirm that there are only a few known suppliers who are able to provide the goods, works or services. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 2,
          "group": "",
          "code": "2",
          "label": "2. Inspect whether the approved commercial strategy, authorised the use of the multiple source mechanism. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 3,
          "group": "",
          "code": "3",
          "label": "3. Check that the relevant DAA approved the award of the successful tenderer . (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 4,
          "group": "",
          "code": "4",
          "label": "4. Check the proof that the tenderer is registered on CSD and was tax compliance verified BEFORE submission to DAA) ( Instr note 01 of 2026. (CSD Report) (32-1034: 8.9.3 Multiple Sources",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources"
          ],
          "defaultLevelRaw": "non-compliance"
        },
        {
          "seq": 5,
          "group": "",
          "code": "5",
          "label": "5. Check that the multiple source procurement was reported to NT after finalisation. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-compliance"
        }
      ],
      "supportsGaps": true,
      "gapColumns": {
        "description": "Gaps Identified",
        "complianceLevel": "Compliance level for each GAP",
        "contravention": "Reference of contravention"
      }
    }
  },
  "Other": {
    "Formal Tendering - Contracts": {
      "family": "Other",
      "mechanism": "Formal Tendering - Contracts",
      "sheetName": "Formal Tendering - Contracts",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.1",
          "label": "1.1 Check if the transaction is part of the approved divisional procurement plan (Instruction Note 01 of 2024: 2.1.3)",
          "anchors": [
            "Instruction Note 01 of 2024: 2"
          ],
          "defaultLevelRaw": "noncompliance"
        },
        {
          "seq": 2,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.2",
          "label": "1.2 Check if all Cross Functional Teams (CFT) have been formally appointed in writing (32-1034: 8.8: 8.8.1)",
          "anchors": [
            "32-1034: 8.8"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 3,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.3",
          "label": "1.3 Inspect signed Conflict Declaration status (DoI & NDA) (Inst note 1 of 2026)",
          "anchors": [],
          "defaultLevelRaw": "non compliance PFMA - NDA or non-compliance policies - no DOI"
        },
        {
          "seq": 4,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.4",
          "label": "1.4 Verify that the signed Scope of Work and specification requirements have been obtained and are on file. Possible reference included",
          "anchors": [],
          "defaultLevelRaw": "non-conformance / noncompliance policies"
        },
        {
          "seq": 5,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1.5",
          "label": "1.5 Assess approval of initial commercial strategy by the relevant DAA and Assess if changes to the Commercial Strategy were approved by the relevant DAA before implementation and amendment were made on the published enquiry (Inst note 1 of 2026 3.5b).",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 6,
          "group": "1. Assess compliance at strategy stage of the procurement process",
          "code": "1",
          "label": "1. 6 Verify that Declarations of Interest (DOIs) are signed at the appropriate stages of the procurement process, including after the kick-off meeting and during the evaluation and negotiation phases. Reference to be included",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 7,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.1",
          "label": "2.1 Check if the content of an Enquiry is consistent with the approved Strategy (32-1034: 8.8.4)",
          "anchors": [
            "32-1034: 8.8.4)"
          ],
          "defaultLevelRaw": "potential non-compliance depending on what is in the ITT/RFP"
        },
        {
          "seq": 8,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.2",
          "label": "2.2 Check if the letter of invitation is signed by the designated Procurement Manager (32-1034: 8.8.4 (a))",
          "anchors": [
            "32-1034: 8.8.4 (a))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 9,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.3",
          "label": "2.3 Proof of advertisement to all relevant portals (National Treasury, Eskom Bulletin, and CIDB if is the requirement) (32-1034: 8.8.6)",
          "anchors": [
            "32-1034: 8.8.6)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 10,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.4",
          "label": "2.4 Verify that any extension of the advert closing date is published on the original advertising platform and approved in writing by the relevant Procurement Manager/Middle Manager, in accordance with Procurement Instruction 01 of 2026 (Section 3.9, p. 13).",
          "anchors": [
            "Procurement Instruction 01 of 2026 (Section 3"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 11,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.5",
          "label": "2.5 Check management of clarification queries & publication of responses to the relevant platforms (32-1034: 8.8.6 & 8.8.7)",
          "anchors": [
            "32-1034: 8.8.6"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 12,
          "group": "2. Assess compliance at enquiry stage of the procurement process",
          "code": "2.6",
          "label": "2.6 If the tender was cancelled, check if the tender cancellation process was followed, including approvals, publication of the cancellation and ensuring tender validity (32-1034: 8.8.8 & 8.8.11)",
          "anchors": [
            "32-1034: 8.8.8"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 13,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.1",
          "label": "3.1 Inspect Signed COI & NDA by all evaluators (32-1034: 8.8.12 (a))",
          "anchors": [
            "32-1034: 8.8.12 (a))"
          ],
          "defaultLevelRaw": "non-conformance or non-compliance"
        },
        {
          "seq": 14,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.2",
          "label": "3.2 Verify that attendance register(s) for all technical evaluators’ meetings are kept on file and that the final technical evaluation report(s) are signed off by the relevant technical evaluator(s) and retained on file for audit purposes. (PROCUREMENT INSTRUCTION 01 OF 2026, clause 3.12, p.15)",
          "anchors": [
            "PROCUREMENT INSTRUCTION 01 OF 2026, clause 3"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 15,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.3",
          "label": "3.3 Check if it was established that if a tenderer/its directors are not listed in the Register of Tender defaulters (provided for in PRECCA), NT’s list of restricted suppliers, the Vendor Management Portal, CSD, and Eskom’s Restricted Directors tool (Instr note 01 of 2026 3.26)",
          "anchors": [],
          "defaultLevelRaw": "non-compliance"
        },
        {
          "seq": 16,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.4",
          "label": "3.4 Inspect signed evaluations sheets (e.g., Commercial, Technical, SHEQ, SDL&I, QS / Financial Analysis etc.) (32-1034: 8.8.12)",
          "anchors": [
            "32-1034: 8.8.12)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 17,
          "group": "3. Assess compliance at evaluation stage of the procurement process",
          "code": "3.5",
          "label": "3.5 Check and ensure alignment of evaluations with the approved strategy & enquiry issued (Costitution Section 217)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 18,
          "group": "4. Assess compliance at adjudication & negotiations stage of the procurement process",
          "code": "4.1",
          "label": "4.1 Check alignment of the evaluation outcome and the recommendation made to the DAA (Costitution Section 217)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 19,
          "group": "4. Assess compliance at adjudication & negotiations stage of the procurement process",
          "code": "4.2",
          "label": "4.2 Check approved adjudication reports (evaluation, mandate & feedback) (32-1034: 8.13)",
          "anchors": [
            "32-1034: 8.13)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 20,
          "group": "4. Assess compliance at adjudication & negotiations stage of the procurement process",
          "code": "4.3",
          "label": "4.3 Inspect negotiation pack (Strategy, agenda, signed minutes, DoI etc,) (32-1034: 8.8.12(q))",
          "anchors": [
            "32-1034: 8.8.12(q))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 21,
          "group": "4. Assess compliance at adjudication & negotiations stage of the procurement process",
          "code": "4.4",
          "label": "4.4 Check alignment of the negotiation outcome with the recommendation made to the relevant DAA (32-1034: 8.8.12(q))",
          "anchors": [
            "32-1034: 8.8.12(q))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 22,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.1",
          "label": "5.1 Check if the award is in accordace with the provision of the relevent contract(s) including SDL&I targets e.g. NEC, FIDIC, etc. (32-1034: 8.8.14 (a))",
          "anchors": [
            "32-1034: 8.8.14 (a))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 23,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.2",
          "label": "5.2 Inspect if the award is still within the validity period (internal approval, acceptance of extension from suppliers, publication of the extension).First extension of tender validity must be approved by Procurement/Middle Manager while subsequent validity extensions must be approved by the Senior Manager (Instr note o1 of 2026 :3.9)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 24,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.3",
          "label": "5.3 Inspect if NEC contract is Fully signed by all relevant designated parties, initialled and witnessed (32-1034: 8.8.14 (b))",
          "anchors": [
            "32-1034: 8.8.14 (b))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 25,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.4",
          "label": "5.4 Compare alignment of the awarded contract with SAP. E.g., Target value, contigency, SDL&I etc. (32-1034: 8.8.14 (d))",
          "anchors": [
            "32-1034: 8.8.14 (d))"
          ],
          "defaultLevelRaw": "possible non-compliance if not in line with DAA approval"
        },
        {
          "seq": 26,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.5",
          "label": "5.5 Inspect Compliance of the statutory documents of the awarded supplier (BBBEE, CIDB, CSD etc.) and tax compliance verified BEFORE submission to DAA (32-1034: 10.2.1 & 8.8.12)( Instr note 01 of 2026 : 3.14 and 3.24 )",
          "anchors": [
            "32-1034: 10.2.1"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 27,
          "group": "5. Assess compliance during contracting phase",
          "code": "5",
          "label": "5. 6 Verify that the CSD report is obtained and that supplier tax compliance is confirmed and documented at all relevant stages of the procurement process, including the mandate to negotiate and conclude, the evaluation stage, and the feedback/reporting stage.",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 28,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.7",
          "label": "5.7 Check if the contract has foreign component, if so, check if the forward cover was taken in line with the relevant threshold (32-1034: 10.1.10)",
          "anchors": [
            "32-1034: 10.1.10)"
          ],
          "defaultLevelRaw": "non-conformance - possible FWE (Fruitless & Wasteful Expenditure)"
        },
        {
          "seq": 29,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.8",
          "label": "5.8 Check if the contract has foreign content equal or above 5 million US Dollars, if so was the certificate for NIPP obtained from DTI? (Eskom Preferential Procurement Policy: 2.2.6.3)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 30,
          "group": "6. Assess compliance on Award Publication of the tender",
          "code": "6.1",
          "label": "6.1 Inspect proof of publication of successful and unsuccessful tenders on the National Treasury eTender Portal, Eskom Portal and CIDB Portals . (32-1034: 8.8.14 (C))",
          "anchors": [
            "32-1034: 8.8.14 (C))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 31,
          "group": "7. Assess compliance on Documents Management process",
          "code": "7.1",
          "label": "7.1 Inspect if all relevant documents are uploaded on Eskom Electronic Document Management System (EDMS) (32-1034: 8.2.2)",
          "anchors": [
            "32-1034: 8.2.2)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 32,
          "group": "7. Assess compliance on Documents Management process",
          "code": "7.2",
          "label": "7.2 Verify that the Declaration Consent Form (DCF), specifically designed to enhance governance, is utilised for all NEC and FIDIC forms of construction contracts. Ensure that a completed DCF is available and retained on file for each contract awarded by Eskom.",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 33,
          "group": "7. Assess compliance on Documents Management process",
          "code": "7.3",
          "label": "7.3 Check alignment of the physical file and EDMS (32-1034: 8.2.2)",
          "anchors": [
            "32-1034: 8.2.2)"
          ],
          "defaultLevelRaw": "not applicable"
        }
      ]
    },
    "Informal Tendering - PO's": {
      "family": "Other",
      "mechanism": "Informal Tendering - PO's",
      "sheetName": "Informal Tendering - PO's",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.1",
          "label": "1.1 Check if the transaction does not exceed a maximum value of R1m. (32-1034: 8.7.1)",
          "anchors": [
            "32-1034: 8.7.1)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 2,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.2",
          "label": "1.2 Check if the transaction is executed by the accredited Procurement Practitioner. E.g PIE , Forex Etc. (32-1034: 8.3.1 and 8.7.2)",
          "anchors": [
            "32-1034: 8.3.1 and 8.7.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 3,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.3",
          "label": "1.3 Check if the Hierarchy of Suppliers was followed.(32-1034: Appendix C:C2)",
          "anchors": [
            "Appendix C:C2)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 4,
          "group": "2. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "2.1",
          "label": "2.1 Check if the RFQ was issued via the CSD platform/System (Prucurement Instruction Note 03 of 2025)",
          "anchors": [
            "Instruction Note 03 of 2025"
          ],
          "defaultLevelRaw": "Depends on when the transaction took place vs departure"
        },
        {
          "seq": 5,
          "group": "2. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "2.2",
          "label": "2.2 Check if it was established that if a tenderer/its directors are not listed in the Register of Tender defaulters (provided for in PRECCA), NT’s list of restricted suppliers, the Vendor Management Portal, CSD, and Eskom’s Restricted Directors tool (Instr note 01 of 2026 3.26)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 6,
          "group": "2. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "2.3",
          "label": "2.3 Check if the issued RFQ included the scope, specifications and price schedules, as well as any drawings that were applicable (32-1034: Appendix C-C3.2)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "Depends - which doc is legislative. i.e SBD4"
        },
        {
          "seq": 7,
          "group": "2. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "2.4",
          "label": "2.4 Check if the following documents were attached to the RFQ and stipulated as mandatory tender returnables for evaluation: 1 Authorisation Form; 2. Integrity Pact & Integrity Declaration Form, 3. Declaration of Shareholding and Directorship, 4. SBD 4 form (Bidder’s Declaration of Interest) (32-1034: Appendix C-C3.4)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 8,
          "group": "2. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "2.5",
          "label": "2.5 Check if the functionality and SDL&I requirements were applicable, if so, were they issued with the RFQ pack.(32-1034: Appendix C-C3.8 and C3.10)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "Depends is \"6\" an Eskom requirement?"
        },
        {
          "seq": 9,
          "group": "2. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "2.6",
          "label": "2.6 Check if CSD was used to source suppliers (Minimum of 6 suppliers)(32-1034: Appendix C-C4.",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 10,
          "group": "2. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "2.7",
          "label": "2.7 If the CSD platform was not available to source suppliers, check if a screenshot was taken as evidence and approval was sought from the Procurement Manager to deviate from using the CSD platform including conducting market analysis to identify possible suppliers. (32-1034: Appendix C-C4)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 11,
          "group": "2. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "2.8",
          "label": "2.8 In case there were any queries from invited suppliers: Check how queries were handled and managed in line with the Constitutional principles S217 (Constitution 217 & CSD etendering process)",
          "anchors": [
            "Constitutional principles S217 (Constitution 217 & CSD etendering process"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 12,
          "group": "2. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "2.9",
          "label": "2.9 If the RFQ was cancelled, check if the approval was sought from the relevant Procurement Manager (32-1034: Appendix C-C6)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 13,
          "group": "3. Assess compliance at evaluation level of the procurement process",
          "code": "3.1",
          "label": "3.1 Check signed evaluations sheets (e.g., Commercial, Technical, SHEQ, SDL&I, QS etc.) (32-1034: Appendix C-C7)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 14,
          "group": "3. Assess compliance at evaluation level of the procurement process",
          "code": "3.2",
          "label": "3.2 Check if the End-user and the Procurement Practitioner have completed a conflict of interest declaration (COI) (32-1034: Appendix C-C7.2)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 15,
          "group": "3. Assess compliance at evaluation level of the procurement process",
          "code": "3.3",
          "label": "3.3 Check if the recommended supplier was the highest score in terms of the PPPFA, subject to the application of objective criteria if those were specified in the RFQ (32-1034: Appendix C-C7.7 & PPR2022)",
          "anchors": [
            "Appendix C",
            "PPPFA",
            "PPR2022"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 16,
          "group": "3. Assess compliance at evaluation level of the procurement process",
          "code": "3.4",
          "label": "3.4 Check if the Procurement Practitioner did ascertain that the prices are fair, reasonable and market-related before recommending an order / contract (32-1034: Appendix C-C7.8)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 17,
          "group": "4.Assess compliance at adjudication & negotiations level of the procurement process",
          "code": "4.1",
          "label": "4.1 Check if the adjudication reports are approved by relevant DAA in accordance with DOA (evaluation, mandate & feedback) (32-1034: 8.7.2)",
          "anchors": [
            "32-1034: 8.7.2)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 18,
          "group": "4.Assess compliance at adjudication & negotiations level of the procurement process",
          "code": "4.2",
          "label": "4.2 Check the negotiation process followed (32-1034: Appendix C-C9)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 19,
          "group": "4.Assess compliance at adjudication & negotiations level of the procurement process",
          "code": "4.3",
          "label": "4.3 Check alignment of the negotiation outcome with the recommendation made to the relevant DAA (32-1034: Appendix C-C8)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 20,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.1",
          "label": "5.1 Check if award is in line with the approval from the relevant DAA (minute/report) (32-1034: Appendix C-C8)",
          "anchors": [
            "Appendix C"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 21,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.2",
          "label": "5.2 Check if the award is still within the validity period (internal approval, acceptance of extension from suppliers, publication of the extension) (Costitution Section 217)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 22,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.3",
          "label": "5.3 Compare alignment of the awarded PO with SAP amount (Good governance)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 23,
          "group": "5. Assess compliance during contracting phase",
          "code": "5.4",
          "label": "5.4 Inspect Compliance of the statutory documents of the awarded supplier (BBBEE, CIDB, CSD etc.) and tax compliance verified BEFORE submission to DAA (32-1034: 10.2.1 & 8.8.12)( Instr note 01 of 2026 : 3.14 and 3.24 )",
          "anchors": [
            "32-1034: 10.2.1"
          ]
        }
      ]
    },
    "LPO": {
      "family": "Other",
      "mechanism": "LPO",
      "sheetName": "LPO",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "LPO number",
        "LPO value",
        "LPO Buyer",
        "Snr Manager for the LPO buyer",
        "Approver by Cost Centre owner equivalent to Snr Manager"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1 Check the Validity /Training of a appointment by cost centre manager not lower than a Senior manager and availability of a file",
          "code": "1.1",
          "label": "1.1 Inspect the appointment letter and check its validity and whether training was provided.(32-1034: 3.5.14 and 8.5.3)",
          "anchors": [
            "32-1034: 3.5.14 and 8.5.3)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 2,
          "group": "1 Check the Validity /Training of a appointment by cost centre manager not lower than a Senior manager and availability of a file",
          "code": "1.2",
          "label": "1.2 Are documents saved on the Eskom Electronic Document management system for Audit trail (EDMS)?.(32-1034: 8.2.2)",
          "anchors": [
            "32-1034: 8.2.2)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 3,
          "group": "2. Identifying when it is permissible to use the LPO mechanism",
          "code": "2.1",
          "label": "2.1 Is the purchase for non-complex goods or services (32-1034: 8.5.1)",
          "anchors": [
            "32-1034: 8.5.1)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 4,
          "group": "2. Identifying when it is permissible to use the LPO mechanism",
          "code": "2.2",
          "label": "2.2 Is the purchase for once-off goods or services (32-1034: 8.5.1)",
          "anchors": [
            "32-1034: 8.5.1)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 5,
          "group": "2. Identifying when it is permissible to use the LPO mechanism",
          "code": "2.3",
          "label": "2.3 Is the purchase for non-stock goods. (32-1034: 8.5.1)",
          "anchors": [
            "32-1034: 8.5.1)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 6,
          "group": "2. Identifying when it is permissible to use the LPO mechanism",
          "code": "2.4",
          "label": "2.4 Is the purchase for goods or services not included in any existing contracts with suppliers (32-1034: 8.5.1)",
          "anchors": [
            "32-1034: 8.5.1)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 7,
          "group": "2. Identifying when it is permissible to use the LPO mechanism",
          "code": "2.5",
          "label": "2.5 Does the LPO purchase exceed the R30k threshold (32-1034: 8.5.1)",
          "anchors": [
            "32-1034: 8.5.1)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 8,
          "group": "2. Identifying when it is permissible to use the LPO mechanism",
          "code": "2.6",
          "label": "2.6 Is the CPA applicable to the LPO (32-1034: 8.5.1)",
          "anchors": [
            "32-1034: 8.5.1)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 9,
          "group": "2. Identifying when it is permissible to use the LPO mechanism",
          "code": "2.7",
          "label": "2.7 Forex should not apply. Is it applied on this LPO? (32-1034: 8.5.1)",
          "anchors": [
            "32-1034: 8.5.1)"
          ],
          "defaultLevelRaw": "possible non-compliance - possible FWE"
        },
        {
          "seq": 10,
          "group": "3. Enquiry/RFQ",
          "code": "3.1",
          "label": "3.1 Is PR or Written request available from an end-user? (Instr note 01 of 2026 : 3.6)",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 11,
          "group": "3. Enquiry/RFQ",
          "code": "3.2",
          "label": "3.2 Is there an Enquiry/RFQ?(32-1034: Appendix A: A3.1)",
          "anchors": [
            "Appendix A: A3.1)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 12,
          "group": "3. Enquiry/RFQ",
          "code": "3.3",
          "label": "3.3 Was the Hierarchy followed (32-1034: Appendix A:A2.)",
          "anchors": [
            "Appendix A:A2.)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 13,
          "group": "3. Enquiry/RFQ",
          "code": "3.4",
          "label": "3.4 Were 3 suppliers selected from the CSD system. Proof of CSD report (32-1034: Appendix A A4.2)",
          "anchors": [
            "Appendix A"
          ],
          "defaultLevelRaw": "Depend, is 3 an Eskom requirement?"
        },
        {
          "seq": 14,
          "group": "3. Enquiry/RFQ",
          "code": "3.5",
          "label": "3.5 Check if it was established that if a tenderer/its directors are not listed in the Register of Tender defaulters (provided for in PRECCA), NT’s list of restricted suppliers, the Vendor Management Portal, CSD, and Eskom’s Restricted Directors tool (Instr note 01 of 2026 3.26)",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 15,
          "group": "3. Enquiry/RFQ",
          "code": "3.6",
          "label": "3.6 Was the RFQ issued via email with BCC and audit trail evidence (delivery/read receipts) (Instr Note 1 of 2026: 3.6)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 16,
          "group": "3. Enquiry/RFQ",
          "code": "3.7",
          "label": "3.7 Were correct RFQ templates and cataloguing requirements applied (Instr note 1 of 20206 : 3.6)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 17,
          "group": "3. Enquiry/RFQ",
          "code": "3.8",
          "label": "3.8 Proof of Procurement manager approval in cases where suppliers not identified via CSD/market research/analysis (32-1034: Appendix A: C4.5 and Instr Note 01 of 2026 : 3.6",
          "anchors": [
            "Appendix A: C4.5 and Instr Note 01 of 2026 : 3.6"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 18,
          "group": "3. Enquiry/RFQ",
          "code": "3.9",
          "label": "3.9 Was the specific goals requested from SDL&I (32-1034: 8.5.1)",
          "anchors": [
            "32-1034: 8.5.1)"
          ]
        },
        {
          "seq": 19,
          "group": "4. Evaluation",
          "code": "4.1",
          "label": "4.1 Has the LPO not been awarded to highest-ranked tenderer based on SDL&I justification. (32-1034: Appendix A & PPR 2022)",
          "anchors": [
            "Appendix A",
            "PPR 2022"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 20,
          "group": "4. Evaluation",
          "code": "4.2",
          "label": "4.2 Is the justification of not awarding to the highest ranked tenderer included in the enquiry document (32-1034: Appendix A: A10.1)",
          "anchors": [
            "Appendix A: A10.1)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 21,
          "group": "4. Evaluation",
          "code": "4.3",
          "label": "4.3 Inpect the Authorisation Form and Integrity Declaration Form, Declaration of Shareholding and Directorship, and SBD 4(Bidders Declaration of Interest) as part of LPO returnables (32-1034: Appendix A :A3.5)",
          "anchors": [
            "Appendix A :A3.5)"
          ],
          "defaultLevelRaw": "Depends - which doc is legislative . i.e SBD4"
        },
        {
          "seq": 22,
          "group": "4. Evaluation",
          "code": "4.4",
          "label": "4.4 Verification of the market-related prices - proof (32-1034: Appendix A : A6)",
          "anchors": [
            "Appendix A : A6)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 23,
          "group": "4. Evaluation",
          "code": "4.5",
          "label": "4.5 Proof of tax compliance (32-1034: Appendix A : A7)",
          "anchors": [
            "Appendix A : A7)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 24,
          "group": "4. Evaluation",
          "code": "4.6",
          "label": "4.6 LPO reference to Eskom General Conditions of Purchase (32-1034: Appendix A : A8)",
          "anchors": [
            "Appendix A : A8)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 25,
          "group": "4. Evaluation",
          "code": "4.7",
          "label": "4.7 LPO Orders created using separate and individual catalogued and/or STG records that accurately describe the goods, works and services as the supplier has indicated on the quotation? (32-1034: Appendix A : A8)",
          "anchors": [
            "Appendix A : A8)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 26,
          "group": "5. Approval",
          "code": "5.1",
          "label": "5.1 Did the DAA confirm that the prices to be paid are within the price check prices and are market related? (32-1034: Appendix A:A10.3)",
          "anchors": [
            "Appendix A:A10.3)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 27,
          "group": "5. Approval",
          "code": "5.2",
          "label": "5.2 Is the order signed? (32-1034: Appendix A:A11)",
          "anchors": [
            "Appendix A:A11)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 28,
          "group": "No modifications will be allowed on LPO orders",
          "code": "6.1",
          "label": "6.1 Has the LPO been modified (32-1034:8.5.1)",
          "anchors": [
            "32-1034:8.5.1)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        }
      ]
    },
    "Emergency": {
      "family": "Other",
      "mechanism": "Emergency",
      "sheetName": "Emergency",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User",
        "Approver of the Emergency Request Form"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Assess the declaration of the emergency procurement route",
          "code": "1.1",
          "label": "1.1 Approved Emergency Request Form by the relevant Eskom DE / GE / MD / GM ERI? (32-1034: 8.9.4 (b) (c))",
          "anchors": [
            "32-1034: 8.9.4 (b) (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 2,
          "group": "1. Assess the declaration of the emergency procurement route",
          "code": "1.2",
          "label": "1.2 Check if the detailed motivation aligns with the identified risk and criterion for use of Emergency Procurement route (32-1034: 8.9.4 (a))",
          "anchors": [
            "32-1034: 8.9.4 (a))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 3,
          "group": "1. Assess the declaration of the emergency procurement route",
          "code": "1.3",
          "label": "1.3 Check if the actions needed to mitigate harm or to prevent the threat from materialising were provided? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 4,
          "group": "1. Assess the declaration of the emergency procurement route",
          "code": "1.4",
          "label": "1.4 Was it confirmed if the emergency scope does not fall within the scope of an existing site / OU contract? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 5,
          "group": "1. Assess the declaration of the emergency procurement route",
          "code": "1.5",
          "label": "1.5 Was it confirmed if the emergency in question will require several payments, in which case a contract must have been established? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 6,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.1",
          "label": "2.1 Did the situation poses an immediate risk to health, life, property, or the environment ? (32-1034: Par 8.9.4 (a))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 7,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.2",
          "label": "2.2 Did the situation and identified risk called for urgent action? (32-1034: Par 8.9.4 (a))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 8,
          "group": "2. Assess the legitimacy of the emergency situation",
          "code": "2.3",
          "label": "2.3 Was there insufficient time to invite competitive tenders? (32-1034: Par 8.9.4 (a))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 9,
          "group": "3. Assess compliance with the identification of the supplier",
          "code": "3.1",
          "label": "3.1 Check if there is a valid quotation from the identified supplier stating the estimated scope, value and time (32-1034: Par 8.9.4 (c))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 10,
          "group": "3. Assess compliance with the identification of the supplier",
          "code": "3.2",
          "label": "3.2 Check if it was established that if a tenderer/its directors are not listed in the Register of Tender defaulters (provided for in PRECCA), NT’s list of restricted suppliers, the Vendor Management Portal, CSD, and Eskom’s Restricted Directors tool (Instr note 01 of 2026 3.26)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 11,
          "group": "3. Assess compliance with the identification of the supplier",
          "code": "3.3",
          "label": "3.3 Was the quotation requested after the GE / MD / DE / GM ERI has approved or declared the emergency? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 12,
          "group": "3. Assess compliance with the identification of the supplier",
          "code": "3.4",
          "label": "3.4 Conflict of Interest (COI) by the end-user when the supplier was identified (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 13,
          "group": "4. Assess compliance with the adjudication process",
          "code": "4.1",
          "label": "4.1 Was the Emergency Submission Report supported and signed-off by the GE / MD / DE / GM ERI? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 14,
          "group": "4. Assess compliance with the adjudication process",
          "code": "4.2",
          "label": "4.2 Was the Emergency Submission Report submitted to the DAA for ratification at its next sitting or as soon as possible after the declaration of the emergency? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 15,
          "group": "4. Assess compliance with the adjudication process",
          "code": "4.3",
          "label": "4.3 Was the Emergency Submission Report approved by the DAA? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 16,
          "group": "5. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "5.1",
          "label": "5.1 Was ZEM PR created on SAP? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 17,
          "group": "5. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "5.2",
          "label": "5.2 Was the approval from the DAA and other supporting documentation attached on the PR? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 18,
          "group": "5. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "5.3",
          "label": "5.3 Is all documentation uploaded on the Eskom Document Management System (EDMS)? (32-1034: 8.2.2)",
          "anchors": [
            "32-1034: 8.2.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 19,
          "group": "6. Assess compliance with the statutory requirements",
          "code": "6.1",
          "label": "6.1 Valid BBBEE certificate or sworn affidavit of the awarded supplier (32-1034: 10.2.1)",
          "anchors": [
            "32-1034: 10.2.1)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 20,
          "group": "6. Assess compliance with the statutory requirements",
          "code": "6.2",
          "label": "6.2 CSD Report of the awarded supplier (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 21,
          "group": "6. Assess compliance with the statutory requirements",
          "code": "6.3",
          "label": "6.3 SBD4 bidder’s disclosure form of the awarded supplier (32-1034: 8.8.4 (k))",
          "anchors": [
            "32-1034: 8.8.4 (k))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 22,
          "group": "Section 7",
          "code": "7.1",
          "label": "7.1 Is the order /contract aligned with the approval from the DAA? (32-1034: 8.9.4 (c))",
          "anchors": [
            "32-1034: 8.9.4 (c))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 23,
          "group": "Section 7",
          "code": "7.2",
          "label": "7.2 Inspect Compliance of the statutory documents of the awarded supplier (BBBEE, CIDB, CSD etc.) and tax compliance verified BEFORE submission to DAA (32-1034: 10.2.1 & 8.8.12)( Instr note 01 of 2026 : 3.14 and 3.24 )",
          "anchors": [
            "32-1034: 10.2.1"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 24,
          "group": "Section 7",
          "code": "7.3",
          "label": "7.3 Was the Emergency Procurement reported to NT and to the AGSA within a month after finalisation of the procurement via OCPO? (Procurement Instruction 09 of 2024 (3.26))",
          "anchors": [
            "Procurement Instruction 09 of 2024 (3"
          ],
          "defaultLevelRaw": "possible non-compliance"
        }
      ]
    },
    "Urgent": {
      "family": "Other",
      "mechanism": "Urgent",
      "sheetName": "Urgent",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "Responsible Senior Manager Procurement",
        "End-User",
        "Responsible General Manager",
        "Approver of the Urgent Request Form"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.1",
          "label": "1.1 Approved Urgent Procurement Request Form by the relevant GE/Corporate GM/Subsidiary CEO? (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 2,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.2",
          "label": "1.2 Check if the detailed motivation aligns with the conditions and circumstances for use of urgent procurement route (Procurment Instructtion 2 of 2025 (a))",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 3,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.3",
          "label": "1.3 Were the steps that will be taken in order to prevent future deviation from competitive tendering and to prevent future reliance on the urgent procurement process stated on the Urgent Procurement Request Form? (Procurment Instructtion 2 of 2025 (a))",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 4,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.4",
          "label": "1.4 Was the contract period provided on the Urgent Procurement Request Form and was it limited to a maximum period of twelve months? (Procurment Instructtion 2 of 2025 (a))",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 5,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.5",
          "label": "1.5 After evaluating the urgent situation did the Power Station Manager / GM provide actions needed to prevent the threat from materialising and supported by the Senior Procurement Manager? (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 6,
          "group": "1. Assess the declaration of the urgent procurement route",
          "code": "1.6",
          "label": "1.6 Did the Senior Procurement Manager confirmed that the urgent scope does not fall within the scope of an existing site / OU contract? (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 7,
          "group": "2. Assess the legitimacy of the urgent situation",
          "code": "2.1",
          "label": "2.1 Was early delivery of critical importance? (Procurment Instructtion 2 of 2025 (a))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 8,
          "group": "2. Assess the legitimacy of the urgent situation",
          "code": "2.2",
          "label": "2.2 Was it impossible or impractical for Eskom to invite competitive bids? (Procurment Instructtion 2 of 2025 (a))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 9,
          "group": "2. Assess the legitimacy of the urgent situation",
          "code": "2.3",
          "label": "2.3 Was it proven that the urgent situation is not due to improper/lack of planning? (Procurment Instructtion 2 of 2025 (a))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 10,
          "group": "2. Assess the legitimacy of the urgent situation",
          "code": "2.4",
          "label": "2.4 Did the urgent situation meet any of the following circumstances: • Threats of interruptions in the supply of electricity to customers resulting in load shedding/load reduction and/or production loss; AND/OR • The threat of major consequential expense to Eskom; AND/ OR • The threat of serious damage to Eskom’s reputation. (Procurment Instructtion 2 of 2025 (a))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 11,
          "group": "3. Assess compliance with the identification of the supplier",
          "code": "3.1",
          "label": "3.1 Check if there is a valid quotation from the identified supplier stating the estimated scope, value and time (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 12,
          "group": "3. Assess compliance with the identification of the supplier",
          "code": "3.2",
          "label": "3.2 Was the quotation requested after the GE/Corporate GM/Subsidiary CEO has approved the Urgent Procurement Request Form? (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 13,
          "group": "3. Assess compliance with the identification of the supplier",
          "code": "3.3",
          "label": "3.3 Check if end-user, relevant GM, relevant Senior Manager Procurement and GE/Corporate GM/Subsidiary CEO have completed and signed a conflict-of-interest declaration (COI) when the potential supplier was recommended to the DAA (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 14,
          "group": "3. Assess compliance with the identification of the supplier",
          "code": "3.4",
          "label": "3.4 Check if it was established that if a tenderer/its directors are not listed in the Register of Tender defaulters (provided for in PRECCA), NT’s list of restricted suppliers, the Vendor Management Portal, CSD, and Eskom’s Restricted Directors tool (Instr note 01 of 2026 3.26)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 15,
          "group": "4. Assess compliance with the adjudication process",
          "code": "4.1",
          "label": "4.1 Was the Ratification Report approved by the relevant DAA (Check if the DAA that approves the ratification is not the same as the Senior Manager Procurement who supported the request) ? (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 16,
          "group": "4. Assess compliance with the adjudication process",
          "code": "4.2",
          "label": "4.2 In case where a mandate to negotiate was sought from the relevant DAA, check the approved mandate to negotiate report, negotiation pack (agenda, signed negotiation minutes by both parties, signed attendance register by both parties) and approved feedback report by the relevant DAA (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 17,
          "group": "5. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "5.1",
          "label": "5.1 Was the approval from the DAA and other supporting documentation attached on the PR? (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 18,
          "group": "5. Assess compliance with systems (SAP & EDMS) requirements",
          "code": "5.2",
          "label": "5.2 Is all documentation uploaded on the Eskom Document Management System (EDMS)? (32-1034: 8.2.2)",
          "anchors": [
            "32-1034: 8.2.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 19,
          "group": "6. Assess compliance with the statutory requirements",
          "code": "6.1",
          "label": "6.1 Valid BBBEE certificate or sworn affidavit of the awarded supplier (32-1034: 10.2.1)",
          "anchors": [
            "32-1034: 10.2.1)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 20,
          "group": "6. Assess compliance with the statutory requirements",
          "code": "6.2",
          "label": "6.2 CSD Report of the awarded supplier (32-1034: 8.9.5 (b))",
          "anchors": [
            "32-1034: 8.9.5 (b))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 21,
          "group": "6. Assess compliance with the statutory requirements",
          "code": "6.3",
          "label": "6.3 SBD4 bidder’s disclosure form of the awarded supplier (32-1034: 8.8.4 (k))",
          "anchors": [
            "32-1034: 8.8.4 (k))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 22,
          "group": "Section 7",
          "code": "7.1",
          "label": "7.1 Is the order/contract aligned with the approval from the DAA? (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 23,
          "group": "Section 7",
          "code": "7.2",
          "label": "7.2 Inspect Compliance of the statutory documents of the awarded supplier (BBBEE, CIDB, CSD etc.) and tax compliance verified BEFORE submission to DAA (32-1034: 10.2.1 & 8.8.12)( Instr note 01 of 2026 : 3.14 and 3.24 )",
          "anchors": [
            "32-1034: 10.2.1"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 24,
          "group": "Section 7",
          "code": "7.3",
          "label": "7.3 Was the Emergency Procurement reported to NT and to the AGSA within a month after finalisation of the procurement via OCPO? (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 25,
          "group": "Section 7",
          "code": "7.4",
          "label": "7.4 In case where the order/contract was modified: Is there a written support from the Divisional GE/DE/GM ERI? Was the modification approved by the relevant DAA? Was the order/contract duration still kept within the duration of 12 months? (Procurment Instructtion 2 of 2025 (c))",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        }
      ]
    },
    "Sole Source": {
      "family": "Other",
      "mechanism": "Sole Source",
      "sheetName": "Sole Source",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User",
        "Approver of the Sole/Single Justification Form"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1.Identifying when it is permissible to use the Sole Source mechanism",
          "code": "1.1",
          "label": "1.1 Check the fully signed and approved SSJF (Note: Gx approval must include Steering Committee and relevant GE) (32-1034: 8.9.1)",
          "anchors": [
            "32-1034: 8.9.1)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 2,
          "group": "1.Identifying when it is permissible to use the Sole Source mechanism",
          "code": "1.2",
          "label": "1.2 Was an approved SSJF in place before requesting a supplier quotation (Instr note 1 of 2026)",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 3,
          "group": "1.Identifying when it is permissible to use the Sole Source mechanism",
          "code": "1.3",
          "label": "1.3 Did the identified supplier meet the criteria of using a sole source route? (True sole source / OEM / Incompatible Material) (32-1034: 8.9.1 (a))",
          "anchors": [
            "32-1034: 8.9.1 (a))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 4,
          "group": "2. Establishing whether there is competition in the market",
          "code": "2.1",
          "label": "2.1 Was the market research conducted? It can be done using one or more of the following: (32-1034: 8.9.1 (a) 1. Conduct research on recent contracts established for the same scope; 2. Provide evidence based on recent previous open enquiries issued to the market that are not older than 6 months; 3. Together with the SDL&I or Business Intelligence Analysts, conduct desktop market research; 4. Initiate formal testing of the market through non-competitive enquiries such as an EOI or RFI issued through the relevant tender office.",
          "anchors": [
            "32-1034: 8.9.1 (a) 1. Conduct research on recent contracts established for the same scope"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 5,
          "group": "2. Establishing whether there is competition in the market",
          "code": "2.2",
          "label": "2.2 Check the letter from the OEM / IP holder and verification of its content by the Procurement Practitioner (32-1034: 8.9.1 (c))",
          "anchors": [
            "32-1034: 8.9.1 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 6,
          "group": "Section 3",
          "code": "3.1",
          "label": "3.1 Check the approval of the Commercial Strategy and issuing of the Enquiry to the prospective supplier by the relevant DAA (32-1034: 8.9.1 (c))",
          "anchors": [
            "32-1034: 8.9.1 (c))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 7,
          "group": "Section 3",
          "code": "3.2",
          "label": "3.2 Check the appointment of the CFT & DoI (Good governance)",
          "anchors": [],
          "defaultLevelRaw": "Depends, i.e DoI will result in possible non-compliance"
        },
        {
          "seq": 8,
          "group": "Section 3",
          "code": "3.3",
          "label": "3.3 Check if it was established that if a tenderer/its directors are not listed in the Register of Tender defaulters (provided for in PRECCA), NT’s list of restrited suppliers, the Vendor Management Portal, CSD, and Eskom’s Restricted Directors tool (Instr note 01 of 2026 3.26).",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 9,
          "group": "Section 3",
          "code": "3.4",
          "label": "3.4 Check the evaluation process of the prospective supplier’s offer (all applicable evaluation disciplines as per the approved strategy) (32-1034: 8.9.1 (c))",
          "anchors": [
            "32-1034: 8.9.1 (c))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 10,
          "group": "Section 3",
          "code": "3.5",
          "label": "3.5 Check the adjudication process by the relevant DAA (Evaluation / Mandate & Feedback) (32-1034: 8.9.1 (c))",
          "anchors": [
            "32-1034: 8.9.1 (c))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 11,
          "group": "Section 3",
          "code": "3.6",
          "label": "3.6 If negotiations were held, check the evaluation pack (Agenda, signed minutes, DoI & NDA by both parties) (32-1034: 8.9.1 (c))",
          "anchors": [
            "32-1034: 8.9.1 (c))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 12,
          "group": "Section 3",
          "code": "3.7",
          "label": "3.7 Is the relevant Procurement Manager notified when a sole source vendor is engaged across multiple sites for the same scope, to support future Regional, Divisional, or National contract arrangements? (32-1034: 8.9.1 (c))",
          "anchors": [
            "32-1034: 8.9.1 (c))"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 13,
          "group": "Section 3",
          "code": "3.8",
          "label": "3.8 Inspect Compliance of the statutory documents of the awarded supplier (BBBEE, CIDB, CSD etc.) and tax compliance verified BEFORE submission to DAA (32-1034: 10.2.1 & 8.8.12)( Instr note 01 of 2026 : 3.14 and 3.24 )",
          "anchors": [
            "32-1034: 10.2.1"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 14,
          "group": "Section 3",
          "code": "3.9",
          "label": "3.9 Check if the contract is signed by both parties (32-1034: 8.8.14 (b))",
          "anchors": [
            "32-1034: 8.8.14 (b))"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 15,
          "group": "Section 4",
          "code": "4",
          "label": "4. Was the Sole Source transaction reported to NT and to the AGSA within a month after finalisation of the procurement? (Compare alingment with awarded Contract and SAP Taget value,contingency. (Procurement Instruction 09 of 2024 (3.26)",
          "anchors": [
            "Procurement Instruction 09 of 2024 (3"
          ],
          "defaultLevelRaw": "possible non-compliance"
        }
      ]
    },
    "Single Source": {
      "family": "Other",
      "mechanism": "Single Source",
      "sheetName": "Single Source",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User",
        "Approver of the Sole/Single Justification Form"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.1",
          "label": "1.1 Did the identified supplier meet the criteria of using a single source route as indicated in the SSJF? – Source of evidence will be the approved SSJF and the motivation (32-1034: 8.9.2)",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 2,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.2",
          "label": "1.2 Assess the thorough analysis of the market conducted (32-1034: 8.9.2)",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 3,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.3",
          "label": "1.3 Was an approved SSJF in place before requesting a supplier quotation (Instr note 1 of 2026)?",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 4,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.4",
          "label": "1.4 Determine whether the process of identifying the preferred supplier was both transparent and equitable (32-1034: 8.9.2)",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 5,
          "group": "1. Identifying when it is permissible to use the informal tendering mechanism",
          "code": "1.5",
          "label": "1.5 Check the formal cost / benefit analysis conducted to establish whether it is more cost-effective to continue with the on-site, established supplier, or whether it would be beneficial to request competitive proposals.(32-1034: 8.9.2)",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 6,
          "group": "2. Assess compliance with the process followed under Single Source",
          "code": "2.1",
          "label": "2.1 Check if there is an approved SSJF by the Steering Committee (Gx only) and relevant GE (Reference TBC)",
          "anchors": [],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 7,
          "group": "2. Assess compliance with the process followed under Single Source",
          "code": "2.2",
          "label": "2.2 Where the Single Source Procurement mechanism is preferred, Check if there is an approved motivation of SSJF and the Commercial Strategy (32-1034: 8.9.2)",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 8,
          "group": "2. Assess compliance with the process followed under Single Source",
          "code": "2.3",
          "label": "2.3 Inspect signed Conflict Declaration status (DoI & NDA) Inst note 1 of 2026",
          "anchors": [],
          "defaultLevelRaw": "Depends, i.e missing NDA will result in possible non-compliance"
        },
        {
          "seq": 9,
          "group": "2. Assess compliance with the process followed under Single Source",
          "code": "2.4",
          "label": "2.4 Check if it was established that if a tenderer/its directors are not listed in the Register of Tender defaulters (provided for in PRECCA), NT’s list of restrited suppliers, the Vendor Management Portal, CSD, and Eskom’s Restricted Directors tool (Instr note 01 of 2026 3.26).",
          "anchors": [],
          "defaultLevelRaw": "non-compliance"
        },
        {
          "seq": 10,
          "group": "2. Assess compliance with the process followed under Single Source",
          "code": "2.5",
          "label": "2.5 Check the evaluation process of the prospective supplier’s offer (all applicable evaluation disciplines as per the approved strategy) (32-1034: 8.9.2)",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 11,
          "group": "2. Assess compliance with the process followed under Single Source",
          "code": "2.6",
          "label": "2.6 Check if a mandate to negotiate was presented to relevant DAA for adjudication (32-1034: 8.9.2)",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 12,
          "group": "2. Assess compliance with the process followed under Single Source",
          "code": "2.7",
          "label": "2.7 If negotiations were held, check the evaluation pack (Agenda, signed minutes, DoI & NDA by both parties (32-1034: 8.9.2)",
          "anchors": [
            "32-1034: 8.9.2)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 13,
          "group": "2. Assess compliance with the process followed under Single Source",
          "code": "2.8",
          "label": "2.8 Inspect Compliance of the statutory documents of the awarded supplier (BBBEE, CIDB, CSD etc.) and tax compliance verified BEFORE submission to DAA (32-1034: 10.2.1 & 8.8.12)( Instr note 01 of 2026 : 3.14 and 3.24 )",
          "anchors": [
            "32-1034: 10.2.1"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 14,
          "group": "2. Assess compliance with the process followed under Single Source",
          "code": "2.9",
          "label": "2.9 Was the Single Source transaction reported to NT and to the AGSA within a month after finalisation of the procurement? (Procurement Instruction 09 of 2024 Compare alingement with awarded Contract and SAP Taget value, contingency.(3.26))",
          "anchors": [
            "Procurement Instruction 09 of 2024 Compare alingement with awarded Contract and SAP Taget value, contingency"
          ],
          "defaultLevelRaw": "possible non-compliance"
        }
      ]
    },
    "Expansions - Modifications": {
      "family": "Other",
      "mechanism": "Expansions - Modifications",
      "sheetName": "Expansions - Modifications",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Buyer",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "1. Identifying when it is permissible to request a modification",
          "code": "1.1",
          "label": "1.1 Check if the modification met the criteria of modifying the contract: 1. Increase in the approved contract duration; 2. Changes to the conditions of contract; 3. Changes to the contracting parties; 4. Changes to specification, design, or scope; 5. Increase in the quantities of goods, works and services; 6. Changes in the country of origin / manufacture of assets or goods (32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 2,
          "group": "1. Identifying when it is permissible to request a modification",
          "code": "1.2",
          "label": "1.2 All modifications must be supported by the relevant Senior Manager prior to being adjudicated by the relevant DAA. A request for a modification for value that is above the NT modification thresholds (15%/R15m or 20%/R20m, including VAT) and that will need to be reported to NT must be supported in writing by the relevant end-user’s GM, in addition to the relevant Senior Manager, prior to being adjudicated by the relevant DAA and reported to NT.( Instruction note 1-2026 3.8).",
          "anchors": [],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 3,
          "group": "1. Identifying when it is permissible to request a modification",
          "code": "1.3",
          "label": "1.3 Check if there is written confirmation that the envisaged expenditure has been budgeted for. (32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 4,
          "group": "1. Identifying when it is permissible to request a modification",
          "code": "1.4",
          "label": "1.4 Check which form of procurement mechanism is being modified (Note: modifications may not be sought in respect of LPOs, low-value informal tendering, or Emergency Procurement) (32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 5,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.1",
          "label": "2.1 Check if the modification request was requested via Procurement Department when there was still sufficient time to obtain approval for the modification, which must be before the SAP expiry date of the contract. (32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 6,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.2",
          "label": "2.2 Check if it was confirmed that the prices quoted for modification were market related.(32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 7,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.3",
          "label": "2.3 Check if the SDL&I targets / commitments were adjusted in order to benefit from increases in the contract value. (32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 8,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.4",
          "label": "2.4 Check if the risk assessment clearly indicated the reason for the modification or increase to the contingency time / value. (32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 9,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.5",
          "label": "2.5 Check if the request for modification was approved by the relevant DAA (32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "possible non-compliance"
        },
        {
          "seq": 10,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.6",
          "label": "2.6 Check if the authorised supplier’s representative and authorised Eskom representative did sign the amendment / modification to the contract (32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 11,
          "group": "2. Establishing the modification process due diligence",
          "code": "2.7",
          "label": "2.7 Check if the Procurement Practitioner updated the electronic purchasing system (SAP) with the amended contract values and/or time, and/or the amended contingency value and time and filed the original amendment with the rest of the contract documents for audit purposes (32-1034: 8.10)",
          "anchors": [
            "32-1034: 8.10)"
          ],
          "defaultLevelRaw": "non-conformance"
        }
      ]
    },
    "Task Order": {
      "family": "Other",
      "mechanism": "Task Order",
      "sheetName": "Task Orders",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "Task Order Number",
        "Contract Number",
        "PO Number",
        "Value of Task Order",
        "Procurement Practitioner",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "Criteria",
          "code": "1",
          "label": "1. Inspect if the Panel Contract Strategy was approved by the relevant DAA",
          "anchors": []
        },
        {
          "seq": 2,
          "group": "Criteria",
          "code": "2",
          "label": "2. Check the completed Task Order Request Form signed by the relevant delegated authority",
          "anchors": []
        },
        {
          "seq": 3,
          "group": "Criteria",
          "code": "3",
          "label": "3. Check the signed budget confirmation letter by Finance Department",
          "anchors": []
        },
        {
          "seq": 4,
          "group": "Criteria",
          "code": "4",
          "label": "4. Inspect if the task order scope was assessed by the Procurement and SDL&I team for potential target setting and RFP",
          "anchors": []
        },
        {
          "seq": 5,
          "group": "Criteria",
          "code": "5",
          "label": "5. Check if the task order request form was approved by the relevant PCC",
          "anchors": []
        },
        {
          "seq": 6,
          "group": "Criteria",
          "code": "6",
          "label": "6. Check if RFP documents were issued to the Suppliers who qualify in that discipline and in line with the selection processes",
          "anchors": []
        },
        {
          "seq": 7,
          "group": "Criteria",
          "code": "7",
          "label": "7. Inspect the evaluation process of the proposals received from suppliers (e.g., Commercial, Technical, SHEQ, SDL&I, QS / Financial Analysis etc.)",
          "anchors": []
        },
        {
          "seq": 8,
          "group": "Criteria",
          "code": "8",
          "label": "8. Check if task order award recommendation was approved by the relevant PCC",
          "anchors": []
        },
        {
          "seq": 9,
          "group": "Criteria",
          "code": "9",
          "label": "9. Check the sign-offs on the Task Order(s) as per the PCC approvals",
          "anchors": []
        },
        {
          "seq": 10,
          "group": "Criteria",
          "code": "10",
          "label": "10. Compare alignment of the awarded Task Order with the SAP PO amount (Good governance)",
          "anchors": []
        }
      ]
    },
    "Transversal": {
      "family": "Other",
      "mechanism": "Transversal",
      "sheetName": "Transversal",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Procurement Practitioner",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "Section 1",
          "code": "1",
          "label": "1. Inspect the Market research and analysis done to confirm that there are only a few known suppliers who are able to provide the goods, works or services. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 2,
          "group": "Section 2",
          "code": "2",
          "label": "2. Inspect whether the approved commercial strategy, authorised the use of the multiple source mechanism. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 3,
          "group": "Section 3",
          "code": "3",
          "label": "3. Check that the relevant DAA approved the award of the successful tenderer . (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 4,
          "group": "Section 4",
          "code": "4",
          "label": "4. Was tax compliance verified BEFORE submission to DAA. (CSD Report) (32-1034: 8.9.3 Multiple Sources and ) ( Instr note 01 of 2026)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources and ) ( Instr note 01 of 2026)"
          ],
          "defaultLevelRaw": "non-compliance"
        },
        {
          "seq": 5,
          "group": "Section 5",
          "code": "5",
          "label": "5. Check that the multiple source procurement was reported to NT after finalisation. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-compliance"
        }
      ],
      "supportsGaps": true,
      "gapColumns": {
        "description": "Gaps Identified",
        "complianceLevel": "Compliance level for each GAP",
        "contravention": "Reference of contravention"
      }
    },
    "Multiple Sources": {
      "family": "Other",
      "mechanism": "Multiple Sources",
      "sheetName": "Multisource",
      "headerFields": [
        "Division",
        "BU",
        "Brief Description",
        "Supplier Name/Vendor Number",
        "CSD Number",
        "PR number",
        "Contract/PO Number",
        "Value of Contract/PO",
        "Procurement Practitioner",
        "Procurement Manager",
        "End-User"
      ],
      "criteria": [
        {
          "seq": 1,
          "group": "Section 1",
          "code": "1",
          "label": "1. Inspect the Market research and analysis done to confirm that there are only a few known suppliers who are able to provide the goods, works or services. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 2,
          "group": "Section 2",
          "code": "2",
          "label": "2. Inspect whether the approved commercial strategy, authorised the use of the multiple source mechanism. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 3,
          "group": "Section 3",
          "code": "3",
          "label": "3. Check that the relevant DAA approved the award of the successful tenderer . (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-conformance"
        },
        {
          "seq": 4,
          "group": "Section 4",
          "code": "4",
          "label": "4. Check the proof that the tenderer is registered on CSD and was tax compliance verified BEFORE submission to DAA) ( Instr note 01 of 2026. (CSD Report) (32-1034: 8.9.3 Multiple Sources",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources"
          ],
          "defaultLevelRaw": "non-compliance"
        },
        {
          "seq": 5,
          "group": "Section 5",
          "code": "5",
          "label": "5. Check that the multiple source procurement was reported to NT after finalisation. (32-1034: 8.9.3 Multiple Sources)",
          "anchors": [
            "32-1034: 8.9.3 Multiple Sources)"
          ],
          "defaultLevelRaw": "non-compliance"
        }
      ],
      "supportsGaps": true,
      "gapColumns": {
        "description": "Gaps Identified",
        "complianceLevel": "Compliance level for each GAP",
        "contravention": "Reference of contravention"
      }
    }
  }
};
